import {Modal} from '@mantine/core';
import type {FC} from 'react';
import {Z_INDEX} from '../../../../constants/zIndex';
import {ModalCancelButton} from '../ModalCancelButton';
import {ModalSubmitButton} from '../ModalSubmitButton';

/**
 * SP用: ToDo保存後にToDo一覧ページを開くかどうかの確認モーダルのProps
 *
 * @description
 * このモーダルは、SPブラウザのポップアップブロッカー対策として使用される。
 * 非同期処理後のwindow.openはブロックされるため、
 * ユーザーの明示的なクリックアクション（onConfirm）で別タブを開く必要がある。
 */
type OpenTodoPageConfirmModalProps = {
  /** モーダルの開閉状態 */
  opened: boolean;
  /** モーダルを閉じる処理（ToDo一覧を開かずに閉じる） */
  onClose: () => void;
  /** ToDo一覧を開く処理（別タブでwindow.openを実行） */
  onConfirm: () => void;
};

/**
 * SP用: ToDo保存後にToDo一覧ページを開くかどうかの確認モーダル
 *
 * @description
 * SPブラウザではポップアップブロッカーの制限により、
 * 非同期処理後のwindow.openがブロックされるため、
 * ユーザーのクリックアクションで明示的に開く必要がある。
 *
 * @example
 * ```tsx
 * <OpenTodoPageConfirmModal
 *   opened={showModal}
 *   onClose={() => setShowModal(false)}
 *   onConfirm={() => {
 *     window.open(todoPageUrl, '_blank');
 *     setShowModal(false);
 *   }}
 * />
 * ```
 */
export const OpenTodoPageConfirmModal: FC<OpenTodoPageConfirmModalProps> = ({
  opened,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      centered
      radius={16}
      zIndex={Z_INDEX.CONFIRM_MODAL}
    >
      <div className="p-16 text-center">
        <p className="mb-8 text-md font-bold text-black">
          ToDoが保存されました
        </p>
        <p className="text-base mb-24 text-black-2">
          ToDo一覧ページを開きますか?
        </p>
      </div>
      <div className="flex items-center justify-center gap-12">
        <ModalCancelButton onClick={onClose}>閉じる</ModalCancelButton>
        <ModalSubmitButton onClick={onConfirm}>開く</ModalSubmitButton>
      </div>
    </Modal>
  );
};
